export const ONE_DAY_COOKIE_EXPIRED_DATE = 1000 * 60 * 60 * 24;
export const PERSONALIZATION_TECH_RULES = '/pravila-primeneniya-rekomendatelnyh-tehnologiy/';
